import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { TickBoxWrapper as CompiledTickBoxWrapper } from './tickBoxWrapper-compiled';
import { TickBoxWrapper as EmotionTickBoxWrapper } from './tickBoxWrapper-emotion';
export var TickBoxWrapper = function TickBoxWrapper(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledTickBoxWrapper, props) : /*#__PURE__*/React.createElement(EmotionTickBoxWrapper, props);
};
TickBoxWrapper.displayName = 'TickBoxWrapper';